import { MobileAccountBoxHeaderButtonsStyled } from "./styled/MobileAccountBoxStyled";
import { Button } from "react-bootstrap";
import BinIcon from "../../../components/icon/Icon";
import MobileAccountStatButton from "./MobileAccountStatButton";
import React from "react";
import { getIsUserSelectedAccountTypeLive } from "../../../app/appSelectors";
import { useSelector } from "react-redux";
import { getIsRespawnAvailable } from "../../../modules/Bonus/bonusesSelectors";
import useMobileAccountBoxButtonsHandlers from "./useMobileAccountBoxButtonsHandlers";

function MobileAccountBoxHeaderButtons() {
    const isRespawnAvailable = useSelector(getIsRespawnAvailable);
    const isAccountLive = useSelector(getIsUserSelectedAccountTypeLive);

    const {
        handleRespawnButtonClick,
    } = useMobileAccountBoxButtonsHandlers();

    return <MobileAccountBoxHeaderButtonsStyled>
        {
            isAccountLive && isRespawnAvailable &&
            <Button size={'sm'}
                    variant={'tertiary'}
                    className={'square'}
                    onClick={handleRespawnButtonClick}
            >
                <BinIcon name={'IcRebuy'}/>
            </Button>
        }
        <MobileAccountStatButton variant={'tertiary'} size={'sm'}/>
    </MobileAccountBoxHeaderButtonsStyled>;
}

export default MobileAccountBoxHeaderButtons;
